type Props = {
  size: number;
  color?: string;
};

const Television = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 3H2.25C1.83516 3 1.5 3.33516 1.5 3.75V15.375C1.5 15.7898 1.83516 16.125 2.25 16.125H11.1562V18.75H7.125C6.91875 18.75 6.75 18.9188 6.75 19.125V20.25C6.75 20.3531 6.83437 20.4375 6.9375 20.4375H17.0625C17.1656 20.4375 17.25 20.3531 17.25 20.25V19.125C17.25 18.9188 17.0813 18.75 16.875 18.75H12.8438V16.125H21.75C22.1648 16.125 22.5 15.7898 22.5 15.375V3.75C22.5 3.33516 22.1648 3 21.75 3ZM20.8125 14.4375H3.1875V4.6875H20.8125V14.4375Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default Television;
